import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Copyright = createReactComponent("Copyright", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "14id60"
}], ["path", {
  d: "M15 9.354a4 4 0 100 5.292",
  key: "1eezgv"
}]]]);
export default Copyright;